import { render, staticRenderFns } from "./CompareTechSpecs.vue?vue&type=template&id=2cfc0fc6&"
import script from "./CompareTechSpecs.vue?vue&type=script&lang=js&"
export * from "./CompareTechSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports